<template>
  <b-form @submit="onSubmit" autocomplete="off">
    <b-card no-body v-if="user" class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b class="text-secondary">{{ getMetaAction }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button v-if="showSave" type="submit" variant="primary"
              >Salvar</b-button
            >

            <router-link
              :to="{
                name: 'users_list',
              }"
              class="btn btn-outline-muted mr-2"
              >Cancelar</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>

        <b-tab title="Permissoes" v-if="!isProfile">
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.permissoes"
            />
            Permissões
          </template>
          <Permissoes ref="permissoes" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import DadosBasicos from "./Form/DadosBasicos.vue";
import Permissoes from "../components/Form/Permissoes";
import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos, Permissoes },
  props: {
    isProfile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    validations: {
      dados_basicos: true,
      permissoes: true,
    },
  }),
  computed: {
    ...mapState("users", ["user"]),

    getMetaAction() {
      return this.$route.meta.action;
    },
    showSave() {
      return this.isProfile || this.$can("user:create");
    },
  },
  methods: {
    ...mapActions("users", ["ActionSave"]),

    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          this.user.isProfile = this.isProfile;
          await this.ActionSave(this.user);
          this.$emit("saved", this.user.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";

          this.$notifications.addNotification({
            message: error_message,
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      if (!this.isProfile) {
        this.validations.permissoes = this.$refs.permissoes.isValid();
      }

      return Object.values(this.validations).every(Boolean);
    },
    changeComponent($event) {
      return (this.currentComponent = $event);
    },
  },
};
</script>

<style></style>
